import {Component, Input, forwardRef, OnInit, OnDestroy} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-amenity-uses-field',
    templateUrl: './settings-amenity-uses-field.component.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SettingsAmenityUsesFieldComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => SettingsAmenityUsesFieldComponent), multi: true}
    ]
})
export class SettingsAmenityUsesFieldComponent extends AbstractFieldClass implements OnInit, OnDestroy {
    @Input('value') _value = [];
    @Input() title = '';

    constructor(public settingsAmenitiesService: SettingsAmenitiesService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

    apply(): void {
        let oneIsEmpty = false;
        this.value.filter((use) => {
            if(use == '' || use.replace(/&nbsp;/g, '').replace(/\s/g, '') == '') {
                oneIsEmpty = true;
            }
        });
        if(oneIsEmpty) {
            toastr.warning('Use can not be empty');
            return;
        }
        super.apply();
    }

    addEmptyUse() {
        this._value.push('');
        this.isEditMode = true;
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    removeUse(index) {
        this._value.splice(index, 1);
        this.apply();
    }

    validator(value: any): boolean {
        return undefined;
    }

    cancel() {
        super.cancel();
    }

    ngOnDestroy() {
        if(this.isEditMode)
            this.settingsAmenitiesService.selectedItemData.uses = JSON.parse(this.originValue);
    }

}




// WEBPACK FOOTER //
// /app/src/app/components/fields/settings-amenity-uses-field/settings-amenity-uses-field.component.ts